import axios from 'axios';

const STORAGE_KEY = 'classificacao-config';
const API_BASE = process.env.REACT_APP_API_823 || '';
const API_AUTH = { username: 'Portal', password: 'Portal1163' };

export const DEFAULT_CONFIG = {
  alerta: [
    'Unable to complete network request to host',
    'Alerta-Sem',
  ],
  aviso: [
    'Saindo da Contingencia Offline',
    'Atualizacao concluida',
    'Data de Validade do Certificado ja expirou',
    'Cupom nao recuperado - Apos falha catastrofica',
    'Cupom recuperado',
    'Ativado modo Contingencia',
    'Entrando em contingencia',
    'Entrando em Contingencia Offline',
  ],
};

export function getConfig() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return JSON.parse(stored);
  } catch {}
  return DEFAULT_CONFIG;
}

function setLocalConfig(config) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
}

export async function fetchConfigFromServer() {
  const { data } = await axios.get(`${API_BASE}/classificacao`, { auth: API_AUTH });
  setLocalConfig(data);
  return data;
}

export async function saveConfigToServer(config) {
  await axios.put(`${API_BASE}/classificacao`, config, { auth: API_AUTH });
  setLocalConfig(config);
}

export async function resetConfigOnServer() {
  const { data } = await axios.post(`${API_BASE}/classificacao/reset`, null, { auth: API_AUTH });
  setLocalConfig(data);
  return data;
}

export function classificarMensagem(mensagem) {
  const texto = mensagem || '';
  const { alerta, aviso } = getConfig();

  if (alerta.some(s => texto.includes(s))) {
    return { tipo: 'Alerta', nivel: 'Moderado', alertClass: 'alert-warning', badgeClass: 'bg-warning text-dark', ordem: 2 };
  }
  if (aviso.some(s => texto.includes(s))) {
    return { tipo: 'Aviso', nivel: 'Normal', alertClass: 'alert-success', badgeClass: 'bg-success', ordem: 3 };
  }
  return { tipo: 'Exceção', nivel: 'Grave', alertClass: 'alert-danger', badgeClass: 'bg-danger', ordem: 1 };
}
